export default "__VITE_ASSET__afad2e7e__"